import { Type } from "@sinclair/typebox";
import SchemaValidator from "../schema-validator";

const verityResultPermission = new SchemaValidator(
	Type.Object({
		verified: Type.Boolean(),
	}),
);

const portalPermission = new SchemaValidator(
	Type.Array(
		Type.Union([
			Type.Literal("InstituteEdit"),
			Type.Literal("CourseEdit"),
			Type.Literal("VeritySettingsEdit"),
			Type.Literal("CourseView"),
			Type.Literal("LiveProctoringPrivilege"),
			Type.Literal("LiveProctoring"),
		]),
	),
);

const assessmentPermissions = new SchemaValidator(
	Type.Object({
		assessment: Type.Array(Type.Union([Type.Literal("create"), Type.Literal("update"), Type.Literal("read")])),
	}),
);

export default {
	verityResultPermission,
	portalPermission,
	assessmentPermissions,
};
